"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Session_1 = __importDefault(require("@/common/Session"));
const Socket_js_1 = __importDefault(require("@/common/Socket.js"));
const Api_1 = __importDefault(require("@/common/Api"));
const Event_1 = __importDefault(require("@/common/Event"));
const lodash_1 = __importDefault(require("lodash"));
const decimal_js_1 = require("decimal.js");
const moment_1 = __importDefault(require("moment"));
const types = __importStar(require("../mutation-types"));
const LocalStorage_1 = __importDefault(require("@/common/LocalStorage"));
const state = {
    data: {},
    wallet: {},
    session: false,
    tradeHistory: {
        concluded: [],
        concludedPage: {},
        pend: [],
    },
    assetSearchText: "",
    assetHaveCoinToggle: LocalStorage_1.default.get("assetHaveCoinToggle", false),
    smallBalance: LocalStorage_1.default.get("smallBalance", false),
};
const getters = {
    isLogin: (state) => lodash_1.default.get(state, ["session"], false),
    tradeHistory: (state) => lodash_1.default.get(state, ["tradeHistory"], {}),
    concluded: (state) => lodash_1.default.get(state, ["tradeHistory", "concluded"], []),
    concludedPage: (state) => lodash_1.default.get(state, ["tradeHistory", "concludedPage"], {}),
    pend: (state) => lodash_1.default.get(state, ["tradeHistory", "pend"], []),
    feeRate: (state) => lodash_1.default.get(state, ["data", "fee", "maker"], 0),
    withdrawalBanned: (state) => lodash_1.default.get(state, ["data", "meta", "banWithdrawal"], "N") === "Y",
    userName: (state) => lodash_1.default.get(state, ["data", "name"], "회원") || "회원",
    authStep: (state) => lodash_1.default.get(state, ["data", "authInfo", "authStep"], ""),
    authmPhone: (state) => lodash_1.default.get(state, ["data", "mPhone"], ""),
    useOTP: (state) => lodash_1.default.get(state, ["data", "authInfo", "otp"], "N") === "Y",
    otpDate: (state) => lodash_1.default.get(state, ["data", "authInfo", "otpDate"], ""),
    userInfo: (state) => lodash_1.default.get(state, ["data"], {}),
    accounts: (state) => lodash_1.default.get(state, ["data", "accounts"], { deposit: null, withdraw: null }),
    authResidence: (state) => lodash_1.default.get(state, ["data", "authInfo", "residence"], ""),
    hasAccount: (state, getter) => {
        return getter.accounts.deposit !== null;
    },
    wallet: (state, getters) => {
        const wallets = lodash_1.default.get(state, ["wallet"], {});
        for (let k in wallets) {
            wallets[k].coin = getters.coinIdMap[k];
        }
        return wallets;
    },
    coinWallet: (state, getters) => {
        let wallets = lodash_1.default.get(state, ["wallet"], {});
        return wallets;
    },
    walletByCoinName(state, getter) {
        return (coinName) => {
            if (!getter.isLogin) {
                return {};
            }
            const coinInfo = getter.currencySettings[coinName] || {};
            return lodash_1.default.get(getter, ["wallet", coinInfo.id], {});
        };
    },
    authLevel: (state, getters) => {
        if (getters.authResidence === "E") {
            return lodash_1.default.upperCase(getters.authStep) === "E" ? 1 : 5;
        }
        if (getters.useOTP) {
            return lodash_1.default.upperCase(getters.authStep) === "E" ? 1 : 4;
        }
        switch (lodash_1.default.upperCase(getters.authStep)) {
            case "B":
                return 3;
            case "R":
                if (getters.accounts.deposit !== null &&
                    getters.accounts.withdraw !== null) {
                    return 3;
                }
                return 2;
            case "E":
                return 1;
            case "N":
            default:
                return 0;
        }
    },
    authStepLevel: (state, getters) => {
        if (getters.authStep == "R") {
            if (getters.useOTP && getters.authResidence === "E")
                return 3;
            if (getters.useOTP && getters.authResidence !== "E")
                return 2;
            if (!getters.useOTP && getters.authResidence === "E")
                return 1;
            if (!getters.useOTP && getters.authResidence !== "E")
                return 1;
            return 1;
        }
        if (getters.authStep !== "R") {
            if (getters.authStep == "B") {
                if (getters.authmPhone !== "") {
                    if (getters.useOTP && getters.authResidence === "E")
                        return 3;
                    if (getters.useOTP && getters.authResidence !== "E")
                        return 2;
                    if (!getters.useOTP && getters.authResidence === "E")
                        return 1;
                    if (!getters.useOTP && getters.authResidence !== "E")
                        return 1;
                    return 1;
                }
                return 0;
            }
            return 0;
        }
    },
    authForIEO: (state, context) => lodash_1.default.get(context, ["authStepLevel"], 0) >= 3,
    getSmallBalance: (state) => lodash_1.default.get(state, ["smallBalance"], false),
};
const actions = {
    logIn({ commit, state, dispatch }, { id, pw, g_recaptcha_response, ali_token, ali_sig, ali_csessionid, router, params, }) {
        return Api_1.default.User.logIn({
            id,
            pw,
            g_recaptcha_response,
            ali_token,
            ali_sig,
            ali_csessionid,
        }).then((response) => {
            const authStep = lodash_1.default.get(response, ["body", "authInfo", "authStep"]);
            if (lodash_1.default.has(response.body, "token")) {
                if (lodash_1.default.includes(response.body.supportedMeans, "OTP")) {
                    router.push({
                        name: "LoginOTP",
                        params: Object.assign(Object.assign({}, response.body), params),
                    });
                }
                else {
                    router.push({
                        name: "LoginSMS",
                        params: Object.assign(Object.assign({}, response.body), params),
                    });
                }
                return response;
            }
            else if (authStep === "E" || authStep === "N") {
                commit(types.LOGIN, response.body);
                return response;
            }
            else {
                const logInDataException = new Error("로그인 데이터가 상이합니다.");
                logInDataException.code = "-999";
                logInDataException.status = "-999";
                logInDataException.msg = "로그인 데이터가 상이합니다.";
                throw logInDataException;
            }
            return false;
        });
    },
    logOut({ commit, state }) {
        if (!state.session) {
            return false;
        }
        return Api_1.default.User.logOut().then((_res) => {
            if (_res.status === 204) {
                commit(types.LOGOUT);
            }
        });
    },
    authSMS({ commit, dispatch }, { authvalue, token }) {
        return Api_1.default.User.loginAuth({ authvalue, means: "SMS", token }).then((response) => {
            dispatch("getPersonalInfo");
            commit(types.LOGIN, response.body);
            return response;
        });
    },
    authOTP({ commit, dispatch }, { authvalue, token }) {
        return Api_1.default.User.loginAuth({ authvalue, means: "OTP", token }).then((response) => {
            dispatch("getPersonalInfo");
            commit(types.LOGIN, response.body);
            return response;
        });
    },
    getPersonalInfo({ dispatch }) {
        return Promise.all([dispatch("getUserWallet")]);
    },
    getUserWallet({ commit, state }) {
        return Api_1.default.User.getWallet().then((response) => {
            const wallets = lodash_1.default
                .chain(response)
                .get(["body"], [])
                .map((wallet) => {
                return wallet.coinId === 1
                    ? Object.assign(Object.assign({}, wallet), { available: new decimal_js_1.Decimal(parseInt(wallet.total))
                            .sub(Math.ceil(wallet.usingCoin) || 0)
                            .toNumber() }) : Object.assign(Object.assign({}, wallet), { available: new decimal_js_1.Decimal(wallet.total)
                        .sub(wallet.usingCoin || 0)
                        .toNumber() });
            })
                .value();
            commit(types.UPDATE_WALLET, wallets);
            Event_1.default.$emit("walletUpdated");
            return response;
        });
    },
    getUserEmail({ state, commit }) {
        return Api_1.default.User.getUserPrivateInfo("email").then((response) => {
            const email = lodash_1.default.get(response, ["body", "data"], "");
            commit(types.UPDATE_MYINFO, Object.assign(Object.assign({}, state.data), { email }));
            return response;
        });
    },
    updateConcluded({ commit }, params = {}) {
        params = Object.assign({ completed: "Y", page: 1, count: 10, fromDate: (0, moment_1.default)()
                .subtract(3, "M")
                .toISOString(), toDate: (0, moment_1.default)().toISOString() }, params);
        return Api_1.default.User.tradeHistory(params).then((response) => {
            commit(types.UPDATE_TRADE_HISTORY, {
                concludedPage: response.pagination,
                concluded: lodash_1.default.map(response.body, (row) => {
                    return Object.assign(Object.assign({}, row), { total: +new decimal_js_1.Decimal(row.chePrice).mul(row.cheAmount) });
                }),
            });
        });
    },
    updatePend({ state, commit }, params = {}) {
        params = Object.assign(Object.assign({}, params), { completed: "N", count: 100 });
        return Api_1.default.User.tradeHistory(params).then((response) => {
            let pend = {};
            if (lodash_1.default.has(params, "marketId")) {
                pend = Object.assign(Object.assign({}, state.tradeHistory.pend), { [params.marketId]: response.body });
            }
            else {
                pend = lodash_1.default.groupBy(response.body, "marketId");
            }
            commit(types.UPDATE_TRADE_HISTORY, { pend });
        });
    },
};
const mutations = {
    [types.LOGIN](state, userData) {
        state.data = userData;
        state.session = true;
        try {
            Socket_js_1.default.emit("login");
            Session_1.default.extend();
        }
        catch (e) { }
    },
    [types.LOGOUT](state) {
        state.data = {};
        state.session = false;
        state.tradeHistory = {
            concluded: [],
            concludedPage: {},
            pend: [],
        };
        state.wallet = {};
        Event_1.default.$emit("logout");
        Socket_js_1.default.emit("logout");
        Session_1.default.extend();
    },
    [types.UPDATE_MYINFO](state, data) {
        state.data = data;
        state.session = true;
        Socket_js_1.default.emit("login");
        Session_1.default.extend();
        return true;
    },
    [types.UPDATE_WALLET](state, newData) {
        const walletsByCoinId = lodash_1.default.keyBy(newData, "coinId");
        state.wallet = Object.assign(Object.assign({}, this.state.wallet), walletsByCoinId);
    },
    [types.UPDATE_TRADE_HISTORY](state, data) {
        state.tradeHistory = Object.assign(Object.assign({}, state.tradeHistory), data);
    },
    [types.REMOVE_PEND_ROW](state, { marketId, index }) {
        const pend = [...lodash_1.default.get(state, ["tradeHistory", "pend", marketId], [])];
        pend.splice(index, 1);
        lodash_1.default.set(state, ["tradeHistory", "pend", marketId], pend);
    },
    [types.UPDATE_MYINFO](state, data) {
        state.data = data;
        state.session = true;
        Socket_js_1.default.emit("login");
        Session_1.default.extend();
    },
    updateAssetSearchText(state, text) {
        state.assetSearchText = text;
    },
    updateAssetHaveCoinToggle(state, toggle) {
        state.assetHaveCoinToggle = toggle;
        LocalStorage_1.default.set("assetHaveCoinToggle", Boolean(toggle));
    },
    setSmallBalance(state, data) {
        lodash_1.default.set(state, ["smallBalance"], data);
        LocalStorage_1.default.set("smallBalance", Boolean(data));
    },
};
exports.default = {
    state,
    getters,
    actions,
    mutations,
};
